import Vue from 'vue';

Vue.directive('tooltip-improver', {
  bind(el, binding) {
    const observer = new MutationObserver((mutationList) => {
      mutationList
        .map(({ addedNodes }) => Array.from(addedNodes))
        .flat()
        .filter(node => node.classList.contains('tooltip'))
        .forEach(tooltip => setTimeout(() => handleTooltip(tooltip, binding.value)));
    });

    observer.observe(el, { childList: true });

    el.mutationObserver = observer;
  },
  unbind(el) {
    el.mutationObserver.disconnect();
  },
});

/**
 *
 * @param {HTMLElement} el
 */
function handleTooltip(el, settings) {
  repositionTooltip(el);
}

/**
 * @param {HTMLElement} el
 */
function repositionTooltip(el) {
  const { right } = el.getBoundingClientRect();
  const innerWidth = window.innerWidth - 15; // 15px correction for scrollbar

  if (right > innerWidth) {
    const correction = right - innerWidth;

    el.style.marginLeft = `-${correction}px`;
  }
}

